// extracted by mini-css-extract-plugin
export default {"irregularBanner":"IrregularAttendanceBanner_irregularBanner__z0Ibj"};